import React, { Fragment, useCallback, useEffect, useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import api from "../../api";
import Logo from "../../images/logo.png";
import styles from "../../css/gallery.module.css";

const products = api();
const photos = products.map((product) => ({
  src: product.proImg,
  alt: "Roslindale Food Collective food rescue and community distribution",
}));

const GalleryPage = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const isOpen = activeIndex !== null;

  const close = useCallback(() => setActiveIndex(null), []);

  const showPrev = useCallback((e) => {
    if (e) e.stopPropagation();
    setActiveIndex((i) => (i === null ? i : (i - 1 + photos.length) % photos.length));
  }, []);

  const showNext = useCallback((e) => {
    if (e) e.stopPropagation();
    setActiveIndex((i) => (i === null ? i : (i + 1) % photos.length));
  }, []);

  useEffect(() => {
    if (!isOpen) return undefined;

    const onKey = (e) => {
      if (e.key === "Escape") close();
      if (e.key === "ArrowLeft") showPrev();
      if (e.key === "ArrowRight") showNext();
    };

    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [isOpen, close, showPrev, showNext]);

  return (
    <Fragment>
      <Navbar hclass={"header-style-1"} Logo={Logo} btnClass={"theme-btn-s1"} />
      <PageTitle pageTitle={"Gallery"} pagesub={"Gallery"} />

      <section className={styles.section}>
        <div className={styles.container}>
          <div className={styles.intro}>
            <span className={styles.eyebrow}>Our Community</span>
            <p className={styles.introText}>
              A look at Roslindale Food Collective in action — the volunteers,
              donations, and neighbors who make our weekly food rescue possible.
            </p>
          </div>

          <div className={styles.grid}>
            {photos.map((photo, index) => (
              <button
                type="button"
                key={index}
                className={styles.item}
                onClick={() => setActiveIndex(index)}
                aria-label={`Open photo ${index + 1}`}
              >
                <img src={photo.src} alt={photo.alt} loading="lazy" />
              </button>
            ))}
          </div>
        </div>
      </section>

      {isOpen && (
        <div
          className={styles.lightbox}
          onClick={close}
          role="dialog"
          aria-modal="true"
          aria-label="Photo viewer"
        >
          <button
            type="button"
            className={styles.lightboxClose}
            onClick={close}
            aria-label="Close"
          >
            &times;
          </button>
          <button
            type="button"
            className={`${styles.lightboxNav} ${styles.prev}`}
            onClick={showPrev}
            aria-label="Previous photo"
          >
            &#8249;
          </button>
          <img
            className={styles.lightboxImg}
            src={photos[activeIndex].src}
            alt={photos[activeIndex].alt}
            onClick={(e) => e.stopPropagation()}
          />
          <button
            type="button"
            className={`${styles.lightboxNav} ${styles.next}`}
            onClick={showNext}
            aria-label="Next photo"
          >
            &#8250;
          </button>
        </div>
      )}

      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default GalleryPage;
